import { ReactNode } from 'react';

import { Text } from '@atlaskit/primitives';

interface TestMetricValueProps {
  hasWarning?: boolean;
  children: ReactNode;
}

export const TestMetricValue = ({
  hasWarning,
  children,
}: TestMetricValueProps) => {
  return (
    <Text
      size="medium"
      weight="regular"
      color={hasWarning ? 'color.text.danger' : 'color.text'}
    >
      {children}
    </Text>
  );
};
